import { PluginKey } from '@bangle.dev/pm';

export const IMAGE_SAVE_DIR = 'assets/images';
export const menuKey = new PluginKey('imageMenuKey');
